import React from 'react';
import { motion } from 'framer-motion';

export interface ProgramItem {
  name: string;
  description: string;
  icon: React.ReactNode;
}

interface ProgramListProps {
  items: ProgramItem[];
}

const ProgramList: React.FC<ProgramListProps> = ({ items }) => {
  return (
    <ol className="program-list">
      {items.map((item, index) => (
        <motion.li
          key={item.name}
          className="program-list__item"
          initial={{ opacity: 0, y: 16 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ delay: index * 0.08, duration: 0.45 }}
        >
          <span className="program-list__index" aria-hidden="true">
            {String(index + 1).padStart(2, '0')}
          </span>
          <span className="program-list__icon">{item.icon}</span>
          <div>
            <h3 className="program-list__title">{item.name}</h3>
            <p className="program-list__text">{item.description}</p>
          </div>
        </motion.li>
      ))}
    </ol>
  );
};

export default ProgramList;
